<template>
    <div>
        <span v-if="error" class="text-red-500 text-sm">
            {{ error }}
        </span>
        <submit-button
            type="button"
            class="w-full"
            :loading="loading"
            @click="authenticate"
        >
            <svg class="mr-2" width="16" height="16" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
            </svg>
            Entrar com Microsoft
        </submit-button>
    </div>
</template>

<script>
import { mapWritableState } from "pinia";
import { Store } from "../../../stores/store";
import SubmitButton from "../../forms/SubmitButton.vue";
import * as msal from "@azure/msal-browser";

export default {
    components: { SubmitButton },
    data() {
        return {
            loading: false,
            error: null,
            msalInstance: null,
        };
    },
    computed: {
        ...mapWritableState(Store, ["user"]),
    },
    async mounted() {
        await this.initializeMsal();
    },
    methods: {
        async initializeMsal() {
            const msalConfig = {
                auth: {
                    clientId: "89e2a14b-2bd8-4a60-9f3d-069d3dd7c8f4",
                    authority: "https://login.microsoftonline.com/413e5a98-1e04-494e-ba05-c1ec76e7b8bf",
                    redirectUri: window.location.origin,
                },
                cache: {
                    cacheLocation: "sessionStorage",
                    storeAuthStateInCookie: false,
                },
            };

            this.msalInstance = new msal.PublicClientApplication(msalConfig);
            await this.msalInstance.initialize();
        },

        async authenticate() {
            try {
                this.loading = true;
                this.error = null;

                // Garante que o MSAL está inicializado
                if (!this.msalInstance) {
                    await this.initializeMsal();
                }

                const loginRequest = {
                    scopes: ["openid", "profile", "email", "User.Read"],
                };

                // Autentica com Microsoft via popup
                const response = await this.msalInstance.loginPopup(loginRequest);
                const accessToken = response.accessToken;

                // Envia token para backend validar
                await axios.get("/sanctum/csrf-cookie");
                const loginResponse = await axios.post("/api/auth/microsoft/callback", {
                    access_token: accessToken,
                });

                this.user = loginResponse.data;

                const redirect = this.$route.query.redirect;
                if (redirect) {
                    this.$router.push(decodeURIComponent(redirect));
                } else {
                    this.$router.push({ name: "users" });
                }
            } catch (error) {
                if (error.response) {
                    // Tratamento igual ao login normal
                    if (
                        error.response.data.exception &&
                        error.response.data.device_uuid
                    ) {
                        this.$router.push({
                            name: "validateDevice",
                            params: { uuid: error.response.data.device_uuid },
                        });
                    } else if (error.response.data.expired) {
                        this.$notify(
                            {
                                group: "error",
                                title: "Senha Expirada",
                                text: error.response.data.message,
                            },
                            4000,
                        );
                        this.$router.push({ name: "login" });
                    } else {
                        this.error = error.response.data.message || "Erro ao autenticar com Microsoft";
                        this.$notify(
                            {
                                group: "error",
                                title: "Erro",
                                text: this.error,
                            },
                            4000,
                        );
                    }
                } else if (error.errorCode === "user_cancelled") {
                    // Usuário cancelou o popup
                    this.error = null;
                } else {
                    this.error = "Erro ao autenticar com Microsoft";
                    console.error("Microsoft authentication error:", error);
                }
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
